module.exports = __webpack_public_path__ + "static/media/mailTitan.3247154e.svg";